<header class="app-header" [ngClass]="{ 'jackpot-bg': isJackpotPage }">
  <div class="app-header-wrapper">
    <figure class="app-logo-container" [ngClass]="{ 'lg:ml-56': isJackpotPage }">
      <a class="app-logo-link logo-frame drop-shadow-xl">
        <img class="app-logo" [src]="logoUrl" alt="EUROJACKPOT" />
      </a>
    </figure>

    <div *ngIf="loggedInUser" class="user-profile-container flex items-center space-x-2 cursor-pointer" [matMenuTriggerFor]="userPreference" data-test-id="user-profile">
      <div class="relative">
        <sp-avatar [user]="loggedInUser" [size]="50" [fontSize]="14" [showToolTip]="false" [clickable]="false"></sp-avatar>
      </div>
      <div *ngIf="impersonated" class="relative w-12 h-12 right-8 opacity-90">
        <sp-avatar [user]="impersonated" [size]="50" [fontSize]="14" [showToolTip]="false" [clickable]="false"></sp-avatar>
      </div>
    </div>
    <div *ngIf="!loggedInUser" class="user-profile-container flex items-center space-x-2 cursor-pointer">
      <button routerLink="/login" class="main-nav-link flex items-start h-full gap-2 text-white">
        <mat-icon class="material-icons-outlined">login</mat-icon>
        <ng-container i18n>Login</ng-container>
      </button>
    </div>

    <mat-menu #userPreference="matMenu">
      <button mat-menu-item routerLink="/assets">
        <mat-icon class="material-icons-outlined">settings</mat-icon>
        <ng-container i18n>Internal</ng-container>
      </button>
      <button mat-menu-item routerLink="/user/profile">
        <mat-icon class="material-icons-outlined">settings</mat-icon>
        <ng-container i18n>Profile</ng-container>
      </button>
      <button mat-menu-item (click)="logoutUser()" data-test-id="button-logout-profile">
        <mat-icon class="material-icons-outlined">logout</mat-icon>
        <ng-container i18n>Logout</ng-container>
      </button>
      <button *ngIf="impersonated" mat-menu-item (click)="logoutUser(true)" matTooltip="You impersonate this user, click to logout and switch back to your role">
        <mat-icon class="material-icons-outlined">people_alt</mat-icon>{{ impersonated.name }}
      </button>
    </mat-menu>
  </div>
</header>
